import Swal from 'sweetalert2';

import { basicMsg, htmlMsg, msg as swalMsg } from "../../actions/swal_msg";

import { SUPPORT_NUMBER, SUPPORT_NUMBER_VIEW } from "../../constants/constants";
import { getExplicitCoupon, removeExplicitCoupon, syncExplicitCoupon } from './couponSession';

const getOpenPayErrorMsg = (description) => {
    if (description === 'The order_id has already been processed')
        return 'Incidente al procesar ID de su pedido';
    else if (description === 'amount valor numérico fuera de los límites (se esperaba <10 dígitos>.<3 dígitos)')
        return 'Incidente con el valor total $ de su pedido (revise decimales)';
    else if (description === 'BAD_PRECISION_AMOUNT')
        return 'Incidente con el valor total $ de su pedido';
    else return description;
};

// nefro_reference solo necesario para pago con PayPal
// ya que no abandonamos el sitio de Nefrópolis
export const returnMsg = async (body, method) => {
    const couponMessages = {
        'coupon-email-required': 'Introduce el correo autorizado para tu cupón.',
        'coupon-email-not-eligible': 'El cupón no está disponible para el correo indicado.',
        'coupon-already-reserved-or-used': 'Este cupón ya está reservado en un pedido pendiente o fue utilizado con este correo. Continúa tu pedido pendiente.',
        'coupon-already-used': 'Este cupón ya fue utilizado con este correo.',
        'coupon-no-uses-available': 'Los usos disponibles de este cupón se agotaron o están reservados.',
        'coupon-unavailable': 'El cupón ya no está vigente o disponible.',
        'coupon-payment-verification-pending': 'Estamos verificando tu intento de pago anterior. No generes otro pago todavía.',
        'order-already-paid': 'Este pedido ya fue pagado.',
        'payment-verification-pending': 'Estamos verificando tu intento de pago anterior. No generes otro pago todavía.',
        'payment-link-unavailable': 'La referencia sigue activa, pero su enlace de pago no está disponible.',
        'order-not-found': 'No pudimos encontrar el pedido que intentas pagar.'
    };
    if (couponMessages[body.msg]) {
        swalMsg('warning', 'Cupón y pago', couponMessages[body.msg]);
        return { status: false };
    }
    if (body.msg === 'miss')
        swalMsg('warning', 'Checkout',
        'Falta información en su pedido');
    else if (body.msg === 'invalid-token') {
        swalMsg('warning', 'Checkout',
        'Su carrito ha expirado');
        localStorage.removeItem('cart-token');
    } else if (body.msg === 'cart-not-found')
        swalMsg('warning', 'Checkout',
        'No hemos podido cargar su carrito');
    // no se encontró producto en BD || no hay stock
    else if (body.msg === 'product-issue') {
        const { notFound, outOfStock, unavailable } = body.resp;
        let txt = '';
        if (notFound && notFound.length > 0) {
            txt += `<div style="margin-bottom: .5rem;">
            <h6>Los siguientes productos ya no están disponibles:</h6>
            <div><ul style="text-align: left;">`;
            for (const e of notFound) {
                txt += `<li>${e.title}</li>`;
            };
            txt += '</ul></div></div>';
        }
        if (outOfStock && outOfStock.length > 0) {
            txt += `<div style="margin-bottom: .5rem;">
            <h6>No hay disponibilidad suficiente de los siguientes productos:</h6>
            <div><ul style="text-align: left;">`;
            for (const e of outOfStock) {
                txt += `<li>${e.title}</li>`;
            };
            txt += '</ul></div></div>';
        }
        if (unavailable && unavailable.length > 0) {
            txt += `<div style="margin-bottom: .5rem;">
            <h6>Estos productos ya no se pueden comprar en línea:</h6>
            <div><ul style="text-align: left;">`;
            for (const e of unavailable) {
                txt += `<li>${e.title}: ${e.message}</li>`;
            }
            txt += '</ul></div></div>';
        }
        htmlMsg('warning', 'Checkout',
        `<h5 style="margin-bottom: 2rem;">Se encontraron problemas en su carrito</h5>${txt}`);
        return {
            status: false,
            reviewCart: true
        };
    } else if (['cart-promotions-changed', 'promotion-expired'].includes(body.msg)) {
        const { expiredPromos, ...legacyCart } = body.resp || {};
        const snapshot = body.msg === 'cart-promotions-changed' ? body.resp?.cart : legacyCart;
        const cartData = Array.isArray(snapshot?.item) && snapshot?.summary ? snapshot : undefined;
        if (cartData) syncExplicitCoupon(cartData.coupon, getExplicitCoupon());
        await Swal.fire({
            title: 'Revisa tu pedido actualizado',
            icon: 'warning',
            text: 'Cambió el precio, una promoción o el cupón de tu carrito. Revisa los importes y el método de envío antes de volver a confirmar el pago.',
            confirmButtonText: 'Revisar mi pedido',
            allowOutsideClick: false
        });
        // Nunca reintenta el pago automáticamente con un importe distinto.
        return { status: false, cartData, reviewCart: true };
    } else if (body.msg === 'btl-coupon-invalid') {
        removeExplicitCoupon();
        const reasons = {
            'btl-coupon-inactive': 'El código médico fue desactivado.',
            'btl-coupon-not-started': 'El código médico todavía no inicia su vigencia.',
            'btl-coupon-expired': 'El código médico ha expirado.',
            'btl-product-set-missing': 'No está disponible el catálogo de productos participantes.',
            'btl-no-eligible-products': 'El carrito ya no contiene productos participantes.',
            'btl-shipping-recalculation-required': 'Es necesario seleccionar nuevamente el método de envío.',
            'btl-shipping-mismatch': 'El costo de envío cambió.',
            'btl-total-mismatch': 'El total del carrito cambió.'
        };
        swalMsg(
            'warning',
            'Código médico',
            reasons[body.resp?.reason] || 'El código médico cambió y debe revisarse nuevamente.'
        );
        return { status: false, cartData: body.resp?.cart };
    } else if (['shipping-recalculation-required', 'shipping-mismatch'].includes(body.msg)) {
        swalMsg('warning', 'Envío', 'Selecciona nuevamente un método de envío de costo regular.');
    } else if (['server-err', 'summary-err'].includes(body.msg))
        swalMsg('error', 'Checkout',
        'Ocurrió un incidente. Intente de nuevo, por favor');
    else if (body.msg === 'openpay-err') { // error con ID de pedido en Openpay
        const { description } = body.resp;
        const contact_text = `Contáctenos por favor: <a href="tel:+${SUPPORT_NUMBER}">${SUPPORT_NUMBER_VIEW}</a>`;
        const text = description ? `${
            getOpenPayErrorMsg(description.trim())
        }. ${contact_text}` : `Incidente al generar su pedido. ${contact_text}`;
        htmlMsg('error', 'Checkout', text);
    } else if (body.msg === 'evopayments-err') // error en petición con EvoPayments
        swalMsg('warning', 'Checkout', 'No se pudo proceder con el pago');
    else if (body.msg === 'order-not-created')
        basicMsg('No se pudo generar su pedido');
    else if (body.msg === 'order-err')
        basicMsg(`Incidente al generar su pedido con ${method}`);
    else
        swalMsg('warning', 'Checkout',
        'Inténtelo de nuevo, por favor');
    return { status: false };
};
